import { createAction } from "@reduxjs/toolkit";
export const updateNetIncome = createAction('updateNetIncome');